import React from 'react';
interface ProgressBarProps {
  progress: number; // 0 to 100
  label?: string;
  showPercentage?: boolean;
  variant?: 'default' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
  className?: string;
}
export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  label,
  showPercentage = true,
  variant = 'default',
  size = 'md',
  className = ''
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));
  const variants = {
    default: 'bg-fpg-navy',
    success: 'bg-status-success',
    warning: 'bg-status-warning',
    error: 'bg-status-error'
  };
  const sizes = {
    sm: 'h-1.5',
    md: 'h-2.5'
  };
  return <div className={`w-full ${className}`} data-id="element-221">
      {(label || showPercentage) && <div className="flex justify-between items-center mb-1.5" data-id="element-222">
          {label && <span className="text-xs font-medium text-text-secondary" data-id="element-223">
              {label}
            </span>}
          {showPercentage && <span className="text-xs font-medium text-text-primary" data-id="element-224">
              {clampedProgress}%
            </span>}
        </div>}
      <div className={`w-full bg-surface-secondary rounded-full overflow-hidden ${sizes[size]}`} data-id="element-225">
        <div className={`h-full rounded-full transition-all duration-500 ease-out ${variants[variant]}`} style={{
        width: `${clampedProgress}%`
      }} data-id="element-226" />
      </div>
    </div>;
};